import { render, staticRenderFns } from "./ModalLayer.vue?vue&type=template&id=71fea3e9&scoped=true"
import script from "./ModalLayer.vue?vue&type=script&lang=ts"
export * from "./ModalLayer.vue?vue&type=script&lang=ts"
import style0 from "./ModalLayer.vue?vue&type=style&index=0&id=71fea3e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fea3e9",
  null
  
)

export default component.exports